import { CustomTemplatedMessageVariables } from 'generated-graphql/types';

export const SOURCING_EXTERNAL_DEFAULT_SUBJECT_LINE = `Job opportunity - {{${CustomTemplatedMessageVariables.JobTitle}}} at {{${CustomTemplatedMessageVariables.EmployerName}}}`;
